// extracted by mini-css-extract-plugin
var _1 = "XGlWUv5pLdIbWzMwNpOb";
export { _1 as "structuralResponseTable" }
